export const ContactFormCategory: string = 'Contact Form';
export const ContactFormCompletedAction: string = 'Contact Form: Completed';
